module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("To Vin Richards, Keith McCarty, Mr. Shelton, Mr. Sudduth, and all my musical friends and mentors.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Most especially, to Marcia McNiel Diehl and P. N. Elrod, for being chandeliers in a world of bug zappers.")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Special heartfelt thanks to my editor, Jennifer Sawyer Fisher. She knows why.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4293194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Dedication.vue
// module id = 78
// module chunks = 0